export class Settings {
    //******************************************************************************************************************
    //  SYMBOLS
    //******************************************************************************************************************

    public static readonly SymbolNine: number = 1;
    public static readonly SymbolTen: number = 2;
    public static readonly SymbolJack: number = 3;
    public static readonly SymbolQueen: number = 4;
    public static readonly SymbolKing: number = 5;
    public static readonly SymbolAce: number = 6;
    public static readonly SymbolGreenDragon: number = 7;
    public static readonly SymbolBlueDragon: number = 8;
    public static readonly SymbolWhiteDragon: number = 9;
    public static readonly SymbolRedDragon: number = 10;
    public static readonly SymbolGoldenDragon: number = 11;
    public static readonly SymbolDragonsGate: number = 12;
    public static readonly SymbolRing: number = 13;
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/Settings.ts
 **/